export default __webpack_public_path__ + "static/media/CrudeExtract.b5c4f358.pdf";